import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js";

const AIExecutionFailInsightsChart = ({ dataArray, type }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!dataArray || dataArray.length === 0) return;

    const ctx = chartRef.current.getContext("2d");
    Chart.defaults.global.datasets.bar.barPercentage = 0.25;
    Chart.defaults.global.datasets.bar.maxBarThickness = 10;

    // Destroy previous chart if exists
    if (chartInstance.current) chartInstance.current.destroy();

    // ---- Extract categories and legend values dynamically ----
    const categories = dataArray.map(
      (item) => Object.keys(item.failure_category)[0]
    );

    // Collect all possible legend keys (modules or priorities)
    const legends = [
      ...new Set(
        dataArray.flatMap((item) =>
          (item[type] || []).map((obj) => Object.keys(obj)[0])
        )
      ),
    ];

    // ---- Build grouped data structure ----
    const groupedData = {};
    dataArray.forEach((item) => {
      const cat = Object.keys(item.failure_category)[0];
      groupedData[cat] = {};
      (item[type] || []).forEach((obj) => {
        const key = Object.keys(obj)[0];
        groupedData[cat][key] = obj[key];
      });
    });

    // ---- Generate colors for each dataset ----
    const baseColors = [
      "#3366CC",
      "#DC3912",
      "#FF9900",
      "#109618",
      "#990099",
      "#0099C6",
      "#DD4477",
      "#66AA00",
      "#B82E2E",
      "#316395",
    ];
    const colors = legends.map((_, i) => baseColors[i % baseColors.length]);

    // ---- Create datasets ----
    const datasets = legends.map((legend, idx) => ({
      label: legend,
      data: categories.map((cat) => groupedData[cat]?.[legend] || 0),
      backgroundColor: colors[idx],
      borderColor: colors[idx],
    }));

    // ---- Chart title ----
    const chartTitle =
      type === "module"
        ? "Failure Test Category vs Module"
        : "Failure Test Category vs Priority";

    // ---- Create chart ----
    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: { labels: categories, datasets },
      options: {
        //responsive: true,

        scales: {
          xAxes: [
            {
              fontSize: 16,
              stacked: true,
              ticks: {
                maxTicksLimit: 20,
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              fontSize: 16,
              ticks: {
                stepSize: 25,
              },
            },
          ],
        },
        tooltips: {
          labelColor: "red",
          titleFontSize: 12,
          titleFontColor: "#003C5B",
          bodyFontColor: "black",
          backgroundColor: "#fff",
          color: "black",
        },
        title: {
          text: chartTitle,
          display: true,
          fontColor: "#337AB7",
          fontSize: 16,
          fontStyle: "normal",
        },
        legend: {
          position: "right",
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [dataArray, type]);

  return (
    <div className="ai-canvas-chart">
      <canvas ref={chartRef} />
    </div>
  );
};

export default AIExecutionFailInsightsChart;
